import {Session} from "../../../../../../Server/DB/sessions/@Session.js";
import {moment_local} from "../../../../../../Utils/General/General.js";
import {UPlotValFunc} from "../../../../../../Utils/UI/UPlotDefaults.js";
import {BREATH_INTERVAL_CALC_WINDOW_SIZE_LONG, BREATH_INTERVAL_CALC_WINDOW_SIZE_SHORT, BREATH_EDGE_SHIFT_CALC_WINDOW_SIZE, BREATH_VARIABILITY_ON_INTERVAL_CALC_WINDOW_SIZE, sessionChartColors, BREATH_INTERVAL_PERCENTILE_X_VISUAL_MULTIPLIER, BREATH_INTERVAL_PERCENTILE_X_CALC_WINDOW_SIZE, BREATH_INTERVAL_PERCENTILE_X_THRESHOLD_X, BREATH_INTERVAL_PERCENTILE_X_THRESHOLD_Y} from "../../SessionChartColors.js";

export const DetailChart_series: (uPlot.Series & {key: string})[] = [
	{
		value: UPlotValFunc((self, rawValue)=>{
			const timeInMS = rawValue * 1000;
			const time = moment_local(timeInMS, (self["session"] as Session)?.localOffsetFromUTC); // session set in EEGChart.chart hook's postSet handler
			//return `${time.format("YYYY-MM-DD HH:mm:ss")}.${(timeInMS % 1000).FloorTo(1).toString().padStart(3, "0")}`;
			return `${time.format("HH:mm:ss")}.${(timeInMS % 1000).FloorTo(1).toString().padStart(3, "0")}`; // we don't need date, it's known from overall session
		}),
	} as any,
	{
		label: "Siren",
		value: UPlotValFunc((self, rawValue)=>rawValue.toFixed(2)),
		stroke: sessionChartColors.siren,
		//spanGaps: true,
	},
	{
		label: "B (breath)",
		value: UPlotValFunc((self, rawValue)=>rawValue.toFixed(2)),
		stroke: sessionChartColors.breath_force,
	},
	{
		label: "B->Desync (blend)",
		value: UPlotValFunc((self, rawValue)=>rawValue.ToPercentStr(0)),
		stroke: sessionChartColors.breath_desync,
		scale: "percent", // makes align to 0-1 scale (right side)
	},
	{
		label: "(long)",
		value: UPlotValFunc((self, rawValue)=>rawValue.ToPercentStr(0)),
		stroke: sessionChartColors.breath_desync_long,
		scale: "percent", // makes align to 0-1 scale (right side)
	},
	{
		label: "(short)",
		value: UPlotValFunc((self, rawValue)=>rawValue.ToPercentStr(0)),
		stroke: sessionChartColors.breath_desync_short,
		scale: "percent", // makes align to 0-1 scale (right side)
	},
	{
		label: `B->Interval (${BREATH_INTERVAL_CALC_WINDOW_SIZE_LONG / 60000}m)`,
		value: UPlotValFunc((self, rawValue)=>rawValue.toFixed(2)),
		stroke: sessionChartColors.breath_interval_long,
		//spanGaps: true, // span gaps; both BreathComp and BreathProcessor operate based on "last breath-peak - window-size", so it's not misleading
	},
	{
		label: `(${BREATH_INTERVAL_CALC_WINDOW_SIZE_SHORT / 1000}s)`,
		value: UPlotValFunc((self, rawValue)=>rawValue.toFixed(2)),
		stroke: sessionChartColors.breath_interval_short,
		//spanGaps: true, // span gaps; both BreathComp and BreathProcessor operate based on "last breath-peak - window-size", so it's not misleading
	},
	{
		label: `(${BREATH_INTERVAL_PERCENTILE_X_THRESHOLD_X.ToPercent(1)}-${BREATH_INTERVAL_PERCENTILE_X_THRESHOLD_Y.ToPercent(1)}%, ${BREATH_INTERVAL_PERCENTILE_X_CALC_WINDOW_SIZE / 60000}m)`,
		value: UPlotValFunc((self, rawValue)=>rawValue.toFixed(2)),
		stroke: sessionChartColors.breath_intervalPercentileX,
	},
	{
		label: `(std-dev*, ${BREATH_VARIABILITY_ON_INTERVAL_CALC_WINDOW_SIZE / 60000}m)`,
		value: UPlotValFunc((self, rawValue)=>rawValue.toFixed(2)),
		stroke: sessionChartColors.breath_intervalVariability,
	},
	{
		label: `B->Edge shift (${BREATH_EDGE_SHIFT_CALC_WINDOW_SIZE / 60000}m)`,
		value: UPlotValFunc((self, rawValue)=>rawValue.toFixed(2)),
		stroke: sessionChartColors.breath_edgeShift,
	},
	/*{
		label: `B->Ampl. (${BREATH_AMPLITUDE_CALC_WINDOW_SIZE / 60000}m)`,
		value: UPlotValFunc((self, rawValue)=>rawValue.toFixed(2)),
		stroke: sessionChartColors.breath_amplitude,
	},
	{
		label: `B->Ampl. SD (${BREATH_AMPLITUDE_STD_DEV_CALC_WINDOW_SIZE / 60000}m)`,
		value: UPlotValFunc((self, rawValue)=>rawValue.toFixed(2)),
		stroke: sessionChartColors.breath_amplitudeStdDev,
	},*/
	{
		label: "EEG (L)",
		value: UPlotValFunc((self, rawValue)=>`${rawValue.toFixed(2)}`),
		stroke: sessionChartColors.eeg_left,
	},
	{
		label: "EEG (R)",
		value: UPlotValFunc((self, rawValue)=>`${rawValue.toFixed(2)}`),
		stroke: sessionChartColors.eeg_right,
	},
	{
		label: "EEG",
		value: UPlotValFunc((self, rawValue)=>{
			if (rawValue == null) {
				// todo: interpolate
				return null;
			}
			return rawValue;
		}),
		stroke: sessionChartColors.eegActivity,
		width: 1.5,

		spanGaps: true,

		//scale: "z", // makes align to eeg-activity scale (right side)
		auto: false,
		//paths: paths_stepped,
	},
	{
		label: "Gyro",
		value: UPlotValFunc((self, rawValue)=>{
			if (rawValue == null) {
				// todo: interpolate
				return null;
			}
			return rawValue.toFixed(2);
		}),
		stroke: sessionChartColors.gyro_combinedDeviation,

		spanGaps: true,
	},
	/*InAndroid(0) && {key: "dist_moveNone", name: "Dist_MoveNone", color: HSL(0, 1, .5)},
	InAndroid(0) && {key: "dist_moveMicro", name: "Dist_MoveMicro", color: HSL(120, 1, .5)},
	InAndroid(0) && {key: "dist_moveMacro", name: "Dist_MoveMacro", color: HSL(240, 1, .5)},*/
];